import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useKeycloak } from '@react-keycloak/web';

export function usePlanCancel() {
  const { keycloak } = useKeycloak();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (jobData: object): Promise<object> => {

      const response = await fetch(
        `${import.meta.env.VITE_USER_ENGINE_ENDPOINT}/api/v1/bundles/user_bundle/functions/cancel_subscription`,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${keycloak.token}`
          },
          method: 'POST',
          body: JSON.stringify(jobData),
        }
      );
      const data = await response.json();

      // console.log(data);

      const { message } = data?.data;

      return {
        message: message
      };
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['userPlans']);
    },
  });
}